import React, { useRef, useState } from "react";
import { useHandleClickOutside } from "oolib";
import { AccordionHeader } from "./comps/AccordionHeader";
import { OptionsLightbox } from "./comps/OptionsLightbox";
export const AccordionMultiSelect = ({
  id,
  value,
  lightboxConfig,
  title,
  onChange,
  broadcastExpandState,
  filterConfig,
  onSearchChange,
  observerRef,
  isFetchingNextPage,
  hasNextPage,
  debug
}) => {

  const [ expand, setExpand ] = useState(false);
  const optionHeaderRef = useRef(null)

  const handleAccordionToggle = () => {
    const newExpandState = !expand;
    setExpand(newExpandState);
    broadcastExpandState && broadcastExpandState(newExpandState);
  };

  const handleCloseLightbox = () => {
    setExpand(false);
    broadcastExpandState && broadcastExpandState(false);
  }

  return (
    <>
      <AccordionHeader 
        filterConfig={filterConfig}
        title={title}
        value={value}
        expand={expand}
        onToggle={handleAccordionToggle}
        onChange={onChange}
        id={id}
        lightboxConfig={lightboxConfig}
        optionHeaderRef={optionHeaderRef}
        debug={debug}
      />

      {expand && (
        <OptionsLightbox
          lightboxConfig={lightboxConfig}
          title={title}
          value={value}
          expand={expand}
          onClickOutside={handleCloseLightbox}
          onClose={handleCloseLightbox}
          onChange={onChange}
          onSearchChange={onSearchChange}
          observerRef={observerRef}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
          ref_anchorPoint={optionHeaderRef}
          filterConfig={filterConfig}
        />
      )}
    </>
  );
};
